const useFieldConstants = (currentEventSettings) => {
	const fieldLength =
		currentEventSettings?.gameConfiguration?.general?.fieldLength;

	const endZoneLength =
		currentEventSettings?.gameConfiguration?.general?.endZoneLength;

	const fieldLengthWithEndZones = fieldLength + endZoneLength * 2;

	// Collapse the zone count until each zone is a whole number of yards.
	// Some field lengths do not divide evenly by the configured zones (e.g. a
	// 50yd field with 2 zones/team -> 12.5yd zones). Reducing the count avoids
	// rendering phantom fractional markers (12.5/37.5) and matches the core
	// zone-to-gain layout (50yd -> 1 zone/team of 25yd).
	//
	// Why only flag football needs this: regular/indoor football uses
	// teamZoneQty=1 (2 total zones), so 50yd -> 50/(1*2) = 25, already whole and
	// rendered as a single 25 marker with no extra logic. Flag football uses
	// teamZoneQty=2 (4 total zones) because zone-to-gain needs 4 zones on its
	// 80yd field (80/4 = 20). 80 divides by 4; 50 does not, so the fractional
	// 12.5/37.5 markers only appear for flag football at 50yd.
	let zonesPerTeamQty =
		currentEventSettings?.gameConfiguration?.general?.teamZoneQty;
	while (
		zonesPerTeamQty > 1 &&
		!Number.isInteger(fieldLength / (zonesPerTeamQty * 2))
	) {
		zonesPerTeamQty -= 1;
	}

	const zoneLength = fieldLength / (zonesPerTeamQty * 2);

	const endZoneLengthPct = (endZoneLength * 100) / fieldLengthWithEndZones;

	const zoneLengthPct = (100 - endZoneLengthPct * 2) / (zonesPerTeamQty * 2);

	const downs = currentEventSettings?.gameConfiguration?.general?.downs;

	// Crew-configured markers (flag football). firstDownYardSet lists the
	// zone-to-gain lines; fieldAreaSet lists {start,end,type} regions. Both are
	// display metadata here — the uniform teamZoneQty layout above remains the
	// fallback when the crew has not customized them.
	const firstDownYardSet =
		currentEventSettings?.gameConfiguration?.general?.firstDownYardSet || [];

	const fieldAreaSet =
		currentEventSettings?.gameConfiguration?.general?.fieldAreaSet || [];

	return {
		fieldLength,
		fieldLengthWithEndZones,
		zoneLength,
		endZoneLength,
		zonesPerTeamQty,
		zoneLengthPct,
		endZoneLengthPct,
		downs,
		firstDownYardSet,
		fieldAreaSet
	};
};

export default useFieldConstants;
